import { render } from "./AlarmEventsPage.vue?vue&type=template&id=55d0d254"
import script from "./AlarmEventsPage.vue?vue&type=script&lang=js"
export * from "./AlarmEventsPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__